import { render, staticRenderFns } from "./FileDownload.vue?vue&type=template&id=1582d688&scoped=true"
import script from "./FileDownload.vue?vue&type=script&lang=ts"
export * from "./FileDownload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1582d688",
  null
  
)

export default component.exports